import React, { useContext, useEffect, useState } from 'react';
import { PostData, PutData } from '../../../../services/FetchData';
import ColorPickerField from '../../../../components/Search/ColorPickerField';
import { Button, Col, Form, FormGroup, Row, Spinner } from 'reactstrap';
import { ProductContext } from '../../../../store';
import { toast } from 'react-toastify';
import DetailSkeleton from '../../../../components/Skeleton/DetailSkeleton';
import JavaScriptCodeEditor from '../../../../components/Search/JavaScriptCodeEditor';
import TemplateCard from '../../../../components/Search/TemplateCard';

const PLATFORMS = { MAGENTO: "magento", SHOPIFY: "shopify", BIGCOMMERCE: "bigcommerce", WOOCOMMERCE: "woocommerce", DRUPAL: "drupal" };
const PLATFORM_PREFIX = { [PLATFORMS.MAGENTO]: "magento", [PLATFORMS.SHOPIFY]: "shopify", [PLATFORMS.BIGCOMMERCE]: "bigcommerce", [PLATFORMS.DRUPAL]: "drupal", [PLATFORMS.WOOCOMMERCE]: "woocommerce" };

const getDesignApiConfig = (platform) => {
	const base = platform === PLATFORMS.MAGENTO ? "ms2" : "ms3";
	const prefix = PLATFORM_PREFIX[platform];
	return { base, prefix };
};

const InstantSearch = () => {
	const [instantSearchCustomCss, setInstantSearchCustomCss] = useState(''),
		[designData, setDesignData] = useState(null),
		[selectedTemplate, setSelectedTemplate] = useState('bigImage'),
		[instantSearchDesignSaveLoader, setInstantSearchDesignSaveLoader] = useState(false),
		[instantSearchCssSaveLoader, setInstantSearchCssSaveLoader] = useState(false),
		[designLoader, setDesignLoader] = useState(true);
	const { currentWebsiteId, websiteData, websiteLoader } = useContext(ProductContext);

	const platform = websiteData?.[currentWebsiteId]?.websiteType;
	const { base, prefix } = getDesignApiConfig(platform || "");
	const isMagento = base === "ms2";

	useEffect(() => {
		if (designData !== null && designData.searchResultDesign) {
			const t = designData.searchResultDesign.template;
			setSelectedTemplate(typeof t === "string" ? t : (t?.value ?? "bigImage"));
			const css = designData.customCss?.searchResult ?? designData.customCss ?? "";
			setInstantSearchCustomCss(typeof css === "string" ? css : "");
		}
	}, [designData])

	useEffect(() => {
		if (!currentWebsiteId || !platform) return;
		getDesignConfig()
	}, [currentWebsiteId, platform])

	const handleTemplateSelection = (value) => {
		let updatedObject = {}
		if (value === "design2") {
			updatedObject = {
				...designData,
				searchResultDesign: {
					...designData.searchResultDesign,
					template: value,
					productCardTitles: "FFFFFF",
					productDescription: "AAAAAA",
					productPrice: "DEDEDE",
					itemBackground: "343434",
					sku: "AAAAAA",
					buttonText: "343434",
					buttonBackground: "FFFFFF",
					productBorder: "FFFFFF",
					onHoverBorders: "D3D3D3",
					filterTitles: "AAAAAA",
					filterTitleBackground: "343434",
					filterValues: "AAAAAA",
					filterBackground: "282828",
					filterOnHoverBackground: "343434",
					filterBorderColor: "282828",
					keyPoints: "FFFFFF",
					activeRange: "FFFFFF",
					rangeLeftoverSpace: "676767"
				},
				autoCompleteDesign: {
					...designData.autoCompleteDesign
				}
			}
		} else if (designData.searchResultDesign.template === "design2") {
			updatedObject = {
				...designData,
				searchResultDesign: {
					...designData.searchResultDesign,
					template: value,
					productCardTitles: "333333",
					productDescription: "888888",
					productPrice: "333333",
					sku: "888888",
					buttonText: "FFFFFF",
					buttonBackground: "333333",
					productBorder: "FFFFFF",
					onHoverBorders: "D3D3D3",
					filterTitles: "333333",
					filterValues: "333333",
					filterBackground: "FFFFFF",
					filterOnHoverBackground: "F7F7F7",
					filterBorderColor: "EEEEEE",
					keyPoints: "333333",
					activeRange: "333333",
					rangeLeftoverSpace: "DCDCDC"
				},
				autoCompleteDesign: {
					...designData.autoCompleteDesign,
				}
			}
		} else {
			updatedObject = {
				...designData,
				searchResultDesign: {
					...designData.searchResultDesign,
					template: value
				},
				autoCompleteDesign: {
					...designData.autoCompleteDesign,
				}
			}
		}
		setDesignData(updatedObject)
		setSelectedTemplate(value)
	}

	const handleInstantSearchColorSelection = (value, keyToUpdate) => {
		const updatedObject = {
			...designData,
			searchResultDesign: {
				...designData.searchResultDesign,
				[keyToUpdate]: value
			}
		};
		setDesignData(updatedObject)
	}

	const getDesignConfig = async () => {
		setDesignLoader(true);
		if (isMagento) {
			PostData(base, `api/v1/${prefix}/getDesignDetails`, { websiteId: currentWebsiteId, type: "instantSearch" }, false, true).then(result => {
				if (result !== "Invalid" && result !== "undefined" && result?.status === "success") {
					const sr = result.data?.searchResultdesign || result.data?.searchResultDesign || result.data;
					setDesignData({
						searchResultDesign: sr || {},
						customCss: { searchResult: result.data?.customCss ?? "" },
					});
					setInstantSearchCustomCss(result.data?.customCss ?? "");
				}
				setDesignLoader(false);
			});
		} else {
			PostData(base, `api/v1/${prefix}/getDesign`, { websiteId: currentWebsiteId }).then(result => {
				if (result !== "Invalid" && result !== "undefined" && result?.status === "success") {
					setDesignData(result.data);
				}
				setDesignLoader(false);
			});
		}
	}

	const saveInstantSearchDesign = async () => {
		setInstantSearchDesignSaveLoader(true);
		const data = { ...designData.searchResultDesign, websiteId: currentWebsiteId };
		if (isMagento) {
			PutData(base, `api/v1/${prefix}/updateDesignSearchResult`, data, false, true).then(result => {
				if (result !== "Invalid" && result !== "undefined") {
					if (result?.status === "success") {
						toast.success(result.message);
						if (result.data) setDesignData(prev => prev ? { ...prev, searchResultDesign: result.data } : prev);
					} else toast.error(result?.message || result?.message?.message || "Failed to save");
				}
				setInstantSearchDesignSaveLoader(false);
			});
		} else {
			PostData(base, `api/v1/${prefix}/updateDesignSearchResult`, data).then(result => {
				if (result !== "Invalid" && result !== "undefined") {
					if (result.status === "success") toast.success(result.message);
					else if (result.status === "failure") toast.error(result.message);
					else toast.error(result.message?.message || result?.message);
				}
				setInstantSearchDesignSaveLoader(false);
			});
		}
	}

	const saveInstantSearchCss = async () => {
		setInstantSearchCssSaveLoader(true);
		if (isMagento) {
			PutData(base, `api/v1/${prefix}/updateDesignCustomCss`, {
				websiteId: currentWebsiteId,
				type: "instantSearch",
				customCss: instantSearchCustomCss,
			}, false, true).then(result => {
				if (result !== "Invalid" && result !== "undefined" && result?.status === "success") {
					toast.success(result.message);
				} else toast.error(result?.message || "Failed to save");
				setInstantSearchCssSaveLoader(false);
			});
		} else {
			PostData(base, `api/v1/${prefix}/updateSearchResultCss`, { searchResult: instantSearchCustomCss, websiteId: currentWebsiteId }).then(result => {
				if (result !== "Invalid" && result !== "undefined") {
					if (result.status === "success") toast.success(result.message);
					else if (result.status === "failure") toast.error(result.message);
					else toast.error(result.message?.message || result?.message);
				}
				setInstantSearchCssSaveLoader(false);
			});
		}
	}

	const renderColorsComponent = () => {
		const sr = designData?.searchResultDesign || {};
		const colorStr = (key, fallback = "#333333") => {
			const v = sr[key];
			if (v == null) return fallback;
			if (typeof v === "string") return v;
			if (typeof v === "object" && v.hex != null) return String(v.hex).startsWith("#") ? String(v.hex) : `#${v.hex}`;
			return fallback;
		};
		return (
			<div>
				<div className="mt-4 mb-4">
					<div className="d-flex align-items-center justify-content-between">
						<div>
							<h4>Templates</h4>
							<small className="text-muted">
							Choose your search results page theme. The theme determines which elements will be displayed on the page.
							</small>
						</div>
					</div>
					<div className="d-flex" style={{ marginTop: '10px', paddingLeft: '0px' }}>
						<TemplateCard 
							title={'Bold Discovery'} 
							colors={['#FFFFFF', '#FFFFFF', '#FFFFFF']} 
							selected={selectedTemplate === "bigImage"} 
							onClicked={() => handleTemplateSelection('bigImage')} 
						/>
						<TemplateCard 
							title={'Minimalist Muse'} 
							colors={['#FFFFFF', '#FFFFFF', '#FFFFFF']} 
							selected={selectedTemplate === 'bigImageLegacy'} 
							onClicked={() => handleTemplateSelection('bigImageLegacy')} 
						/>
						<TemplateCard 
							title={'Classic Commerce'} 
							colors={['#FFFFFF', '#FFFFFF', '#FFFFFF']} 
							selected={selectedTemplate === "design1"} 
							onClicked={() => handleTemplateSelection('design1')} 
						/>
						<TemplateCard 
							title={'Vivid Palette'} 
							colors={['#FFFFFF', '#FFFFFF', '#FFFFFF']} 
							selected={selectedTemplate === "design2"} 
							onClicked={() => handleTemplateSelection('design2')} 
						/>
					</div>
				</div>
				<FormGroup className="mb-3">
					<Row>
						<Col>
							<h4>Product Card</h4>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Titles</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdCardTitles" + selectedTemplate}
									initialColor={colorStr("productCardTitles")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "productCardTitles")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Descriptions</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdCardDescription" + selectedTemplate}
									initialColor={colorStr("productDescription")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "productDescription")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Product prices</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdPriceProduct" + selectedTemplate}
									initialColor={colorStr("productPrice")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "productPrice")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">SKU</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdSKU" + selectedTemplate}
									initialColor={colorStr("sku")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "sku")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				{selectedTemplate === 'design2' && (
					<FormGroup className="mb-3">
						<Row className="align-items-center pb-2">
							<Col xs={4}>
								<small className="fw-bold text-uppercase">Item Background</small>
							</Col>
							<Col>
								<div className="d-flex">
									<ColorPickerField
										key={"srdCartProductItemBackground" + selectedTemplate}
										initialColor={colorStr("itemBackground")}
										onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "itemBackground")}
									/>
								</div>
							</Col>
						</Row>
					</FormGroup>
				)}

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Button text</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdButtonText" + selectedTemplate}
									initialColor={colorStr("buttonText")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "buttonText")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">CTA button background</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdButtonBackground" + selectedTemplate}
									initialColor={colorStr("buttonBackground")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "buttonBackground")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				{selectedTemplate !== 'bigImage' && (
					<FormGroup className="mb-3">
						<Row className="align-items-center pb-2">
							<Col xs={4}>
								<small className="fw-bold text-uppercase">Product Border Color</small>
							</Col>
							<Col>
								<div className="d-flex">
									<ColorPickerField
										key={"srdCartProductBorder" + selectedTemplate}
										initialColor={colorStr("productBorder")}
										onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "productBorder")}
									/>
								</div>
							</Col>
						</Row>
					</FormGroup>
				)}

				{(selectedTemplate === 'design1' || selectedTemplate === "design2") && (
					<FormGroup className="mb-3">
						<Row className="align-items-center pb-2">
							<Col xs={4}>
								<small className="fw-bold text-uppercase">On-hover borders</small>
							</Col>
							<Col>
								<div className="d-flex">
									<ColorPickerField
										key={"srdHoverBorders" + selectedTemplate}
										initialColor={colorStr("onHoverBorders")}
										onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "onHoverBorders")}
									/>
								</div>
							</Col>
						</Row>
					</FormGroup>
				)}

				<FormGroup className="mb-3">
					<Row>
						<Col>
							<h4>Filters</h4>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Titles</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdFilterTitle" + selectedTemplate}
									initialColor={colorStr("filterTitles")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "filterTitles")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				{selectedTemplate === 'design2' && (
					<>
						<FormGroup className="mb-3">
							<Row className="align-items-center pb-2">
								<Col xs={4}>
									<small className="fw-bold text-uppercase">Titles background</small>
								</Col>
								<Col>
									<div className="d-flex">
										<ColorPickerField
											key={"srdFilterTitleBackground" + selectedTemplate}
											initialColor={colorStr("filterTitleBackground", "#343434")}
											onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "filterTitleBackground")}
										/>
									</div>
								</Col>
							</Row>
						</FormGroup>
					</>
				)}

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Values</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdFilterValues" + selectedTemplate}
									initialColor={colorStr("filterValues")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "filterValues")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				{selectedTemplate !== 'bigImage' && (
					<>
						<FormGroup className="mb-3">
							<Row className="align-items-center pb-2">
								<Col xs={4}>
									<small className="fw-bold text-uppercase">Background</small>
								</Col>
								<Col>
									<div className="d-flex">
										<ColorPickerField
											key={"srdFilterBackground" + selectedTemplate}
											initialColor={colorStr("filterBackground")}
											onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "filterBackground")}
										/>
									</div>
								</Col>
							</Row>
						</FormGroup>

						<FormGroup className="mb-3">
							<Row className="align-items-center pb-2">
								<Col xs={4}>
									<small className="fw-bold text-uppercase">On-hover background</small>
								</Col>
								<Col>
									<div className="d-flex">
										<ColorPickerField
											key={"srdFilterOnHoverBackground" + selectedTemplate}
											initialColor={colorStr("filterOnHoverBackground")}
											onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "filterOnHoverBackground")}
										/>
									</div>
								</Col>
							</Row>
						</FormGroup>

						<FormGroup className="mb-3">
							<Row className="align-items-center pb-2">
								<Col xs={4}>
									<small className="fw-bold text-uppercase">Filter Border Color</small>
								</Col>
								<Col>
									<div className="d-flex">
										<ColorPickerField
											key={"srdFilterBorderColor" + selectedTemplate}
											initialColor={colorStr("filterBorderColor")}
											onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "filterBorderColor")}
										/>
									</div>
								</Col>
							</Row>
						</FormGroup>
					</>
				)}

				<FormGroup className="mb-3">
					<Row>
						<Col>
							<h4>Price range filter</h4>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Key points</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdKeyPoints" + selectedTemplate}
									initialColor={colorStr("keyPoints")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "keyPoints")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Active range</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdActiveRange" + selectedTemplate}
									initialColor={colorStr("activeRange")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "activeRange")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Range leftover space</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdRangeLeftOverSpace" + selectedTemplate}
									initialColor={colorStr("rangeLeftoverSpace")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "rangeLeftoverSpace")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row>
						<Col>
							<h4>Mobile Filter Button</h4>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Text</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdMobileFilterText" + selectedTemplate}
									initialColor={colorStr("mobileFilterText")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "mobileFilterText")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Background</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdMobileFilterBtnBg" + selectedTemplate}
									initialColor={colorStr("mobileFilterBtnBackground")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "mobileFilterBtnBackground")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row>
						<Col>
							<h4>Miscellaneous</h4>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Navigation highlight</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdNavigationHighlight" + selectedTemplate}
									initialColor={colorStr("navigationHighlight")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "navigationHighlight")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Navigation default</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdNavigationDefault" + selectedTemplate}
									initialColor={colorStr("navigationDefault")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "navigationDefault")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<FormGroup className="mb-3">
					<Row className="align-items-center pb-2">
						<Col xs={4}>
							<small className="fw-bold text-uppercase">Pagination highlight</small>
						</Col>
						<Col>
							<div className="d-flex">
								<ColorPickerField
									key={"srdPaginationHighlight" + selectedTemplate}
									initialColor={colorStr("paginationHighlight")}
									onColorChange={(newColor) => handleInstantSearchColorSelection(newColor, "paginationHighlight")}
								/>
							</div>
						</Col>
					</Row>
				</FormGroup>

				<div className="d-flex justify-content-end">
					<Button
						color="primary"
						className='cta autoWidth'
						disabled={instantSearchDesignSaveLoader}
						onClick={(e) => { e.preventDefault(); saveInstantSearchDesign() }}
					>
						{instantSearchDesignSaveLoader ? 'Loading...' : 'Save'}
					</Button>
				</div>
			</div>
		)
	}

	const supportedPlatforms = [PLATFORMS.MAGENTO, PLATFORMS.SHOPIFY, PLATFORMS.BIGCOMMERCE, PLATFORMS.WOOCOMMERCE, PLATFORMS.DRUPAL];
	if (websiteLoader || !websiteData?.[currentWebsiteId]) return <DetailSkeleton />;
	if (!platform || !supportedPlatforms.includes(platform)) {
		return (
			<div className="designOuterContainer">
				<div className="designInnerContainer">
					<p className="text-muted">Design is not available for this platform.</p>
				</div>
			</div>
		);
	}

	return (
		<div className="designOuterContainer">
			<div className="designInnerContainer">
				{designLoader ? (
					<DetailSkeleton />
				) : (
					<>
						<Row>
							<Col xs={12}>
								<h3 className='mb-3'>Design</h3>
								<div style={{ marginBottom: '20px' }}>
									<h5 className='mb-2'>Colors</h5>
									<p>You can change colors for some elements of a widget's template. Colors depends on the chosen theme.</p>
								</div>
							</Col>
						</Row>
						{designData ? renderColorsComponent() : <DetailSkeleton />}
						<hr className='my-4' />
						<Row>
							<Col xs={12}>
								<h3>Custom CSS</h3>
								<div style={{ marginBottom: '20px', border: '1px solid #ddd', borderRadius: '5px', overflow: 'hidden' }}>
									<JavaScriptCodeEditor
										key={"instantSearchCustomCss"}
										value={instantSearchCustomCss}
										onChange={(value) => {
											setInstantSearchCustomCss(value)
										}}
									/>
								</div>
							</Col>
						</Row>
						<hr className='my-4' />
						<div className="d-flex justify-content-end">
							<Button disabled={instantSearchCssSaveLoader} className='btn-primary cta autoWidth' onClick={(e) => { e.preventDefault(); saveInstantSearchCss() }}>
								{instantSearchCssSaveLoader ? <><Spinner size="sm" /> {"Saving..."}</> : <>{"Save"}</>}
							</Button>
						</div>
					</>
				)
				}
			</div>
		</div>
	);
};

export default InstantSearch;
export { InstantSearch };